<template lang="pug">
.dedicated_line.container-fluid
  .container.custom_container_sm.i_pt_8.i_pb_8.flex_h.flex_sm_v.justify-content-between
    .left
      h5 {{ customerServiceCommon.FooterTitle }}
        span.i_mt_2 {{ customerServiceCommon.FooterSubTitle }}
      p {{ customerServiceCommon.FooterContent }}
    .right.flex_v.flex_sm_h.justify-content-center
      router-link.item.align-items-center.flex_h.justify-content-center.justify-content-md-start.i_ptb_2.i_plr_3.i_mb_2.i_mb_sm_0.i_mr_sm_3(
        tag="a",
        :to="{ name: 'Location' }"
      )
        svg-icon(iconClass="ic_footer_place", className="icon")
        span.i_ml_3 服務據點
      router-link.item.align-items-center.flex_h.justify-content-center.justify-content-md-start.i_ptb_2.i_plr_3.i_mt_2.i_mt_sm_0.i_ml_sm_3(
        v-if="true",
        tag="a",
        :to="{ name: 'CustomerServiceContactUs' }"
      )
        svg-icon(iconClass="ic_footer_mailus", className="icon")
        span.i_ml_3 客服信箱
</template>

<script>
import { getCustomerServiceCommon } from "@/json/customer_service";

export default {
  name: "DedicatedLine",
  data() {
    return {
      customerServiceCommon: {},
    };
  },
  created() {
    this.getCustomerServiceCommon();
  },
  methods: {
    getCustomerServiceCommon() {
      getCustomerServiceCommon().then((response) => {
        this.customerServiceCommon = response.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/dedicated_line";
</style>
